import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// const state = {
// 	sharedData: null
// }


export default new Vuex.Store({
	state: {
		sharedData: null
	},
	mutations: {
		setSharedData(state, data) {
			state.sharedData = data;
		}
	},
	actions: {
		setSharedData({
			commit
		}, data) {
			commit('setSharedData', data);
		}
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js